import { VerifyAddOn_LeadFinder, VerifyAddOn_MapView } from "./endPoint";

//Post Function
const PostRequest = async (Endpoint, Body) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(Body);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(Endpoint, requestOptions);
    const result_1 = await response.json();
    return result_1;
  } catch (error) {
    return null;
  }
};
export const VerifyPaymemt_MapView = (Body) => {
  return PostRequest(VerifyAddOn_MapView, Body);
};

export const VerifyPaymemt_LeadFinder = (Body) => {
  return PostRequest(VerifyAddOn_LeadFinder, Body);
};
